import React, { useEffect } from "react";
import { connect } from "react-redux";
import { /* Button, */ Form, Button as bsButton, FormGroup, Label, Input, FormText, Col, Row, InputGroup, InputGroupAddon, InputGroupButtonDropdown } from "reactstrap";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import { IconButton, Typography, Card, CardContent, Tooltip } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import PopEditorClassic from "../../../../../../components/TinyMCE/PopEditorClassic";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import RestoreIcon from "@material-ui/icons/Restore";
const customStyles = {
  control: (provided, state) => ({
    ...provided,

    backgroundColor: "rgb(58, 59, 60)",
    color: "#ffffffde",
    border: "0px",
    width: "100%",
    maxWidth: "100%",
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    color: "green",
    maxWidth: "100%",
  }),
  input: (provided, state) => ({
    ...provided,
    color: "#ffffffde",
    maxWidth: "100%",
    border: 0,
    ["&:focus"]: {
      outline: 0,
      border: 0,
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#ffffffde",
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#1d1d1d",
    maxWidth: "100%",
    zIndex: 100,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#20a8d8" : "rgb(47, 47, 47)",
    color: "#ffffffde",
    ["&:hover"]: {
      backgroundColor: "#5a5959ba",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#eee",
  }),
};

function AgendaEditView(props) {
  const [question, setQuestion] = React.useState(null);
  const [placeholderOption, newOption] = React.useState("");
  const [modalOpen, toggleModal] = React.useState(false);
  const [editedAgenda, setEditAgenda] = React.useState(null);
  const { selectedAgenda, agenda, restoreAgendaItem } = props;
  const onSave = () => {
    if (editedAgenda) {
      const newAgenda = /* Array.from( */ agenda.map((a) => {
        if (a.agendaItemId == editedAgenda.agendaItemId) {
          a.text = editedAgenda.text;
          a.name = editedAgenda.name;
        }
        return a;
      }); /* ) */
      props.handleAgendaOnChange(newAgenda);
      setEditAgenda(null);
    }
  };
  const deleteAgenda = (deleteIndex) => {
    if (deleteIndex === null) return;
    if (deleteIndex > 0) {
      props.deselectAgendaItem();
      props.deleteAgendaItem(deleteIndex);
    }
  };
  return (
    <Card className="dark-card" style={{ margin: 10, height: "calc(100% - 10px)" }}>
      <CardContent style={{ minHeight: "calc(100% - 40px)", maxHeight: "calc(100% - 40px)" }}>
        <div className="inline-flex" style={{ width: "100%", padding: "0px", margin: "10px 0px", display: "inline-flex" }}>
          <Col className="col-7 text-left">
            <Typography variant="h6" className="primary-text">
              {editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.name : selectedAgenda.name}
            </Typography>
          </Col>
          <Col className="col-5 text-right">
            <IconButton
              className="icon-button-dark"
              disabled={selectedAgenda.agendaItemId < 0}
              style={{
                padding: 15,
                opacity: selectedAgenda.agendaItemId < 0 ? 0.6 : 1,
                margin: "0px 10px",
              }}
              onClick={() => deleteAgenda(selectedAgenda.agendaItemId)}
              edge="end"
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              className="icon-button-dark"
              disabled={selectedAgenda.agendaItemId < 0}
              style={{
                padding: 15,
                opacity: selectedAgenda.agendaItemId < 0 ? 0.6 : 1,
                margin: "0px 10px",
              }}
              onClick={() => restoreAgendaItem(selectedAgenda.agendaItemId)}
              edge="end"
            >
              <Tooltip title={<SystemLabel name="RestoreAgendaItem" />}>
                <RestoreIcon />
              </Tooltip>
            </IconButton>
            <IconButton
              className="icon-button-dark"
              disabled={!editedAgenda}
              style={{
                padding: 15,
                opacity: !editedAgenda ? 0.6 : 1,
                margin: "0px 10px",
              }}
              onClick={() => onSave()}
              edge="end"
            >
              <SaveIcon />
            </IconButton>
            <IconButton
              style={{
                padding: 15,
                margin: "0px 10px",
              }}
              className="icon-button-dark"
              onClick={() => {
                props.deselectAgendaItem();
                if (selectedAgenda.agendaItemId < 0) {
                  props.handleAgendaOnChange(
                    props.agenda.filter((a) => a.agendaItemId !== selectedAgenda.agendaItemId),
                    true
                  );
                }
              }}
              edge="end"
            >
              <CloseIcon />
            </IconButton>
          </Col>
        </div>
        <div style={{ margin: 10 }}>
          <FormGroup>
            <Label className="secondary-text" for="questionName">
              <SystemLabel name="AgendaTitle" />
            </Label>
            <Input
              value={editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.name : selectedAgenda.name}
              onChange={(e) => {
                /*    const a = Object.assign(selectedAgenda);
                               a.name = e.target.value; */
                setEditAgenda({
                  agendaItemId: editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.agendaItemId : selectedAgenda.agendaItemId,
                  name: e.target.value,
                  text: editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.text : selectedAgenda.text,
                });
              }}
              style={{
                backgroundColor: "#3a3b3c",
                marginBottom: "0px",
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "0.875rem",
                borderRadius: "5px",
                padding: "5px 10px",
                border: "0px",
              }}
            />
          </FormGroup>
          <Row form>
            <Col /* md={6} */>
              <FormGroup>
                <Label className="secondary-text" for="exampleEmail">
                  <SystemLabel name="AgendaContent" />
                </Label>
                <div style={{ cursor: "text", zIndex: 100, color: "#FFFFFF99", backgroundColor: "#3a3b3c", border: "0px", padding: "5px 10px", width: "100%", display: "inline-block" }}>
                  {/* {props.eventId == 172 ? */}
                    <PopEditorClassic
                      value={editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.text : selectedAgenda.text}
                      editMode={true}
                      onChange={(e) => {
                        setEditAgenda({
                          agendaItemId: editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.agendaItemId : selectedAgenda.agendaItemId,
                          name: editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.name : selectedAgenda.name,
                          text: e,
                        });
                      }}
                      slimFormat={true}
                      path={"text"}
                      style={undefined}
                    />
                    {/* :
                    <textarea
                      style={{
                        width: "100%",
                        background: "transparent",
                        border: "0px",
                        color: "#9c9c9c",
                        height: 400,
                      }}
                      value={editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.text : selectedAgenda.text}
                      onChange={(e) => {
                        setEditAgenda({
                          agendaItemId: editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.agendaItemId : selectedAgenda.agendaItemId,
                          name: editedAgenda && selectedAgenda.agendaItemId == editedAgenda.agendaItemId ? editedAgenda.name : selectedAgenda.name,
                          text: e.target.value,
                        });
                      }}
                    ></textarea> */}
                  {/* } */}
                </div>
              </FormGroup>
            </Col>
          </Row>
        </div>
      </CardContent>
    </Card>
  );
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(AgendaEditView);
